import { capitalizeEachWord } from "../utils/capitalize";

const useUser = () => {
  const user = JSON.parse(localStorage?.getItem("UserData"));

  // Accessing properties
  const name = user?.user?.name ?? "";
  const email = user?.user?.email ?? "";
  const gender = user?.user?.gender ?? "";
  const address = user?.user?.address ?? "";
  // API currently sends role under "Role.name" (capital R); fall back to "role.name" if needed
  const role = user?.user?.["Role.name"] ?? user?.user?.["role.name"] ?? "";
  const phone = user?.user?.contact_no;
  const category = user?.user?.category_id ?? "";
  const token = user?.tokens;
  const userToken = user?.tokens?.access?.token;
  const userID = user?.user?.id;
  // Capitalizing
  const capitalizedName = capitalizeEachWord(name);
  const capitalizedRole = capitalizeEachWord(role);
  const isSuperAdmin = role.toLowerCase() === "superadmin";
  const isRadiologist = role.toLowerCase() === "radiologist";
  const isSitePerson = role.toLowerCase() === "siteperson";
  const isSubAdmin = role.toLowerCase() === "subadmin";
  const isQualityChecker = role.toLowerCase() === "qualitychecker";

  return {
    name: capitalizedName,
    email,
    gender,
    address,
    role: capitalizedRole,
    phone,
    category,
    token,
    userToken,
    userID,
    isRadiologist,
    isSitePerson,
    isSuperAdmin,
    isSubAdmin,
    isQualityChecker
  };
};

export default useUser;
